module.exports = __webpack_public_path__ + "static/media/robot.894ebdab.jpg";